import {ItemsPos, SectionInterface, StoreWallInterface} from "../../types/store";
import {RailHoles} from "../../../shared";
import {useStoreRoom} from "../../useStoreRoom";

interface IncomingPropsInterface {
    currentShelving: StoreWallInterface;
    id: string | null;
    sectionId: string;
}

export const getSectionItemsYPos = ({currentShelving, id, sectionId}: IncomingPropsInterface) => {
    const room = useStoreRoom.getState();
    const currentSectionIndex = currentShelving.sections.findIndex((section) => section.id === sectionId);
    const prevSectionId = currentShelving.sections[currentSectionIndex - 1]?.id;
    const currentSectionId = currentShelving.sections[currentSectionIndex]?.id;
    if (!currentSectionId) {
        return []
    }

    const currentSectionItemsYPos: Set<ItemsPos> = new Set();

    const minHeight = (room.height - Math.min(currentShelving.sections[currentSectionIndex].leftRackHeight, currentShelving.sections[currentSectionIndex].height)
        - currentShelving.offsetCeiling) / 1000;
    //FIXME почему "/50"
    const values = new Array(Math.ceil(room.height / 50))
        .fill(undefined)
        .map((value, index) => Math.trunc((minHeight + (0.05 * index)) * 1000) / 1000);

    const addHole = (railHole: RailHoles, index: number, value: number, sectionIndex: number, name: string, type: string[]) => {
        const hole = {
            leftLeftRail: railHole.leftLeftRail,
            leftRightRail: railHole.leftRightRail,
            rightLeftRail: railHole.rightLeftRail,
            rightRightRail: railHole.rightRightRail,
            depthFrom: railHole.depthFrom,
            depthTo: railHole.depthTo,
            name: name,
            sectionIndex: sectionIndex,
            type: type,
            positionY: Math.trunc((value + (0.05 * index)) * 1000) / 1000,
            sort: railHole.sort
        }
        currentSectionItemsYPos.add(hole);
    }

    const calcItemsYPos = (section: SectionInterface, sectionIndex: number) => {
        section?.items
            .filter((item) => item.id !== id)
            .forEach((item) => {
                const leftElements = item?.brackets?.left?.elements;
                const center = Math.round(item.position[1] * 1000) / 1000;

                values.forEach((value) => {
                    if (Math.round(Math.abs(value * 1000 - center * 1000)) < 25) {
                        if (leftElements?.find((element) => element?.railHoles)) {
                            leftElements?.forEach((element) => {
                                if (!element.railHoles) return;
                                const railHoles = [...element.railHoles].reverse();
                                railHoles.forEach((railHoles, index) => addHole(railHoles, index, value, sectionIndex, element.name, element.type));
                            })
                        }

                        if (item?.railHoles) {
                            const railHoles = [...item?.railHoles].reverse();
                            railHoles.forEach((railHoles, index) => addHole(railHoles, index, value, sectionIndex, item?.name, item.type));
                        }

                        currentSectionItemsYPos.add({
                            leftLeftRail: false,
                            leftRightRail: false,
                            rightLeftRail: false,
                            rightRightRail: false,
                            name: item?.name,
                            sectionIndex: sectionIndex,
                            type: item?.type,
                            positionY: Math.trunc(value * 1000) / 1000,
                        });
                    }
                });
            });
    }

    calcItemsYPos(currentShelving.sections[currentSectionIndex], currentSectionIndex);
    (currentShelving.sections[currentSectionIndex - 1]) && calcItemsYPos(currentShelving.sections[currentSectionIndex - 1], currentSectionIndex - 1);
    (currentShelving.sections[currentSectionIndex + 1]) && calcItemsYPos(currentShelving.sections[currentSectionIndex + 1], currentSectionIndex + 1);
    //FIXME почему "-25"
    const maxHeight = (room.height - currentShelving.offsetCeiling - 25) / 1000;

    //добавление yPos соединителей, для запрета таскания
    const connectorYPositions: ItemsPos[] = [];

    const addConnectorYPos = (connectorYPos: number, currentSectionIndex: number) => {
        //FIXME почему "+0.2"
        return connectorYPos + 0.2 > maxHeight ?
            undefined :
            connectorYPositions.push({
                leftLeftRail: true,
                leftRightRail: true,
                rightLeftRail: true,
                rightRightRail: true,
                depthFrom: 0,
                positionY: connectorYPos,
                sectionIndex: currentSectionIndex,
                name: "connector",
                type: ["connector"],
            });
    }

    //Необходимо для анализа пересечения с кронштейнами на левой стойке (если она самая первая, либо идет после отступа)
    const firstRack = 'firstRack'
    prevSectionId && currentShelving.connectorYPositions[prevSectionId + firstRack] && currentShelving.connectorYPositions[prevSectionId + firstRack]?.forEach((connectorYPos) => addConnectorYPos(connectorYPos, currentSectionIndex));
    currentShelving.connectorYPositions[currentSectionId + firstRack] && currentShelving.connectorYPositions[currentSectionId + firstRack].forEach((connectorYPos) => addConnectorYPos(connectorYPos, currentSectionIndex));

    prevSectionId && currentShelving.connectorYPositions[prevSectionId]?.forEach((connectorYPos) => addConnectorYPos(connectorYPos, currentSectionIndex));
    currentShelving.connectorYPositions[currentSectionId].forEach((connectorYPos) => addConnectorYPos(connectorYPos, currentSectionIndex));

    connectorYPositions.forEach(currentSectionItemsYPos.add, currentSectionItemsYPos);

    return Array.from(currentSectionItemsYPos)
};
